module.exports = __webpack_public_path__ + "img/22-consultas-docs-geral-lista.fbf0efd7.png";